import React from "react";
import { Routes, Route } from "react-router-dom";
import MainLayout from "../components/MainLayout";
import { useAuth } from "../hooks";
import Home from "../pages/Home";
import Login from "../pages/Login";
import SignUp from "../pages/SignUp";
import Expediente from "../pages/Expediente";
import { Error404 } from "../components/Error404";
import UserListPage from "../pages/Usuarios";
import UsuariosHomologar from "../pages/UsuariosHomologar";
import AxiosInterceptor from "../interceptors/AxiosInterceptor";
import Oficinas from "../pages/Oficinas";
import TiposDeTramitesListPage from "../pages/TipoDeTramite";
import RequisitosListPage from "../pages/Requisitos";
import Notificaciones from "../pages/Notificaciones";
import RecuperarPassword from "../pages/RecuperarPassword";
import ResetPassword from "../pages/ResetPassword";

export function WebRouter() {
  const { user } = useAuth();

  const loadLayout = (Layout, Page) => {
    return (
      <Layout>
        <Page />
      </Layout>
    );
  };

  return (
    <AxiosInterceptor>
      <Routes>
        {!user ? (
          <>
            <Route path="/*" element={<Login />} />
            <Route path="/registracion" element={<SignUp />} />
            <Route
              path="/recuperarPassword"
              element={<RecuperarPassword/>}
            />              
            <Route
              path="/resetPassword/:token"
              element={<ResetPassword/>}
            />              
          </>
        ) : (
          <>
            {["/", "/home"].map((path) => (
              <Route
                key={path}
                path={path}
                element={loadLayout(MainLayout, Home)}
              />
            ))}
            <Route
              path="/expediente"
              element={loadLayout(MainLayout, Expediente)}
            />
            <Route
              path="/usuarios"
              element={loadLayout(MainLayout, UserListPage)}
            />
            <Route
              path="/homologar"
              element={loadLayout(MainLayout, UsuariosHomologar)}
            />
            <Route
              path="/expediente/:id_expediente"
              element={loadLayout(MainLayout, Expediente)}
            />

            <Route
              path="/oficinas"
              element={loadLayout(MainLayout, Oficinas)}
            />

            <Route
              path="/requisitos"
              element={loadLayout(MainLayout, RequisitosListPage)}
            />

            <Route
              path="/tiposDeExpediente"
              element={loadLayout(MainLayout, TiposDeTramitesListPage)}
            />

            <Route
              path="/notificaciones"
              element={loadLayout(MainLayout, Notificaciones)}
            />            
            <Route path="*" element={loadLayout(MainLayout, Error404)} />
          </>
        )}
      </Routes>
    </AxiosInterceptor>
  );
}
